export const getDraftDayDisclaimer = (draftDay) => {
  switch (draftDay?.toString()) {
    case "29":
    case "30":
    case "31":
      return "Payment will be processed on the last day of every month.";
    default:
      return "";
  }
};
